import styled from "styled-components";

export const TimelineContainer = styled.div`
  margin-top: 20px;
  .ant-timeline-item-left {
    text-align: left;
  }
  .ant-timeline-item-head {

  }
  .ant-timeline-item-tail {
    top: 15px;
    left: 20px;
    background-color: ${props => props.theme.colors.primary};
  }
`;

export const TimelineIconCircle = styled.div<{color: string}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    background-color: ${props => props.color};
    color: #fff;
    position: relative;
    left: 15px;
    font-size: 25px;
`;

export const TimelineCard = styled.div`
  background: #fff;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  max-width: 300px;
  width: 100%;
  position: relative;
  left: 30px; /* Adjust to center the card with the dot */
  .date {
    font-weight: bold;
    margin-bottom: 5px;
    color:rgb(54, 54, 54);
  }
  .title {
    font-size: 14px;
  }
`;